import LpaTransferForm from './LpaTransferForm';

export default LpaTransferForm;
